import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, mergeProps as _mergeProps, normalizeClass as _normalizeClass, vShow as _vShow, normalizeStyle as _normalizeStyle, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  ref: "messageMain",
  class: "message-main"
}
const _hoisted_2 = {
  key: 0,
  class: "message-main__thread-title"
}
const _hoisted_3 = {
  key: 3,
  class: "message-main__info"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = ["title", "aria-label"]
const _hoisted_6 = ["title", "aria-label"]
const _hoisted_7 = ["title", "aria-label"]
const _hoisted_8 = ["title", "aria-label"]
const _hoisted_9 = ["title", "aria-label"]
const _hoisted_10 = {
  key: 4,
  class: "message-actions"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_IconForumOutline = _resolveComponent("IconForumOutline")
  const _component_IconCancel = _resolveComponent("IconCancel")
  const _component_NcRichText = _resolveComponent("NcRichText")
  const _component_CallButton = _resolveComponent("CallButton")
  const _component_ConversationActionsShortcut = _resolveComponent("ConversationActionsShortcut")
  const _component_PollCard = _resolveComponent("PollCard")
  const _component_MessageQuote = _resolveComponent("MessageQuote")
  const _component_IconContentCopy = _resolveComponent("IconContentCopy")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_IconReload = _resolveComponent("IconReload")
  const _component_IconAlertCircleOutline = _resolveComponent("IconAlertCircleOutline")
  const _component_IconCheckAll = _resolveComponent("IconCheckAll")
  const _component_IconCheck = _resolveComponent("IconCheck")
  const _component_IconBellOffOutline = _resolveComponent("IconBellOffOutline")
  const _component_IconArrowLeftTop = _resolveComponent("IconArrowLeftTop")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.isThreadStarterMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createVNode(_component_IconForumOutline, { size: 16 }),
          _createTextVNode(" " + _toDisplayString($options.threadTitle), 1)
        ]))
      : _createCommentVNode("", true),
    ($options.isSystemMessage || $options.isDeletedMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["message-main__text", {
				'system-message': $options.isSystemMessage && !$options.showJoinCallButton,
				'deleted-message': $options.isDeletedMessage,
				'message-highlighted': $options.showJoinCallButton,
			}])
        }, [
          ($options.isDeletedMessage)
            ? (_openBlock(), _createBlock(_component_IconCancel, {
                key: 0,
                size: 16
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_NcRichText, {
            text: $options.renderedMessage,
            arguments: $props.richParameters,
            autolink: "",
            dir: "auto",
            "reference-limit": 0
          }, null, 8, ["text", "arguments"]),
          ($options.showJoinCallButton)
            ? (_openBlock(), _createBlock(_component_CallButton, {
                key: 1,
                class: "call-button"
              }))
            : ($options.showConversationActionsShortcut)
              ? (_openBlock(), _createBlock(_component_ConversationActionsShortcut, {
                  key: 2,
                  token: $props.message.token,
                  "object-type": $options.conversation.objectType,
                  "is-highlighted": $options.isLastMessage
                }, null, 8, ["token", "object-type", "is-highlighted"]))
              : ($options.showResultsButton)
                ? (_openBlock(), _createBlock(_component_PollCard, _mergeProps({
                    key: 3,
                    token: $props.message.token,
                    "show-as-button": ""
                  }, $props.message.messageParameters.poll), null, 16, ["token"]))
                : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["message-main__text markdown-message", { 'message-highlighted': $options.isNewPollMessage }]),
          onMouseover: _cache[0] || (_cache[0] = (...args) => ($options.handleMarkdownMouseOver && $options.handleMarkdownMouseOver(...args))),
          onMouseleave: _cache[1] || (_cache[1] = (...args) => ($options.handleMarkdownMouseLeave && $options.handleMarkdownMouseLeave(...args)))
        }, [
          ($options.showQuote)
            ? (_openBlock(), _createBlock(_component_MessageQuote, {
                key: 0,
                message: $props.message.parent
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          _createVNode(_component_NcRichText, {
            text: $options.renderedMessage,
            arguments: $props.richParameters,
            class: _normalizeClass({ 'single-emoji': $options.isSingleEmoji }),
            autolink: "",
            dir: "auto",
            interactive: $props.message.markdown && $setup.isEditable,
            "use-extended-markdown": $props.message.markdown,
            "reference-limit": 1,
            "reference-interactive-opt-in": "",
            onInteractTodo: $options.handleInteraction
          }, null, 8, ["text", "arguments", "class", "interactive", "use-extended-markdown", "onInteractTodo"]),
          ($options.containsCodeBlocks)
            ? _withDirectives((_openBlock(), _createBlock(_component_NcButton, {
                key: 1,
                class: "message-copy-code",
                variant: "tertiary",
                size: "small",
                "aria-label": $options.t('spreed', 'Copy code block'),
                title: $options.t('spreed', 'Copy code block'),
                style: _normalizeStyle({ top: $data.copyButtonOffset }),
                onClick: $options.copyCodeBlock
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconContentCopy, { size: 16 })
                ]),
                _: 1
              }, 8, ["aria-label", "title", "style", "onClick"])), [
                [_vShow, $data.currentCodeBlock !== null]
              ])
            : _createCommentVNode("", true)
        ], 34)),
    (!$options.isDeletedMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", {
            class: _normalizeClass(["date", { 'date--hidden': $options.hideDate }]),
            title: $options.messageDate
          }, _toDisplayString($options.messageTime), 11, _hoisted_4),
          ($props.message.sendingFailure)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                title: $options.sendingErrorIconTitle,
                class: _normalizeClass(["message-status sending-failed", { 'retry-option': $options.sendingErrorCanRetry }]),
                "aria-label": $options.sendingErrorIconTitle,
                tabindex: "0",
                onMouseover: _cache[2] || (_cache[2] = $event => ($data.showReloadButton = true)),
                onFocus: _cache[3] || (_cache[3] = $event => ($data.showReloadButton = true)),
                onMouseleave: _cache[4] || (_cache[4] = $event => ($data.showReloadButton = false)),
                onBlur: _cache[5] || (_cache[5] = $event => ($data.showReloadButton = false))
              }, [
                ($options.sendingErrorCanRetry && $data.showReloadButton)
                  ? (_openBlock(), _createBlock(_component_NcButton, {
                      key: 0,
                      size: "small",
                      "aria-label": $options.sendingErrorIconTitle,
                      onClick: $options.handleRetry
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_IconReload, { size: 16 })
                      ]),
                      _: 1
                    }, 8, ["aria-label", "onClick"]))
                  : (_openBlock(), _createBlock(_component_IconAlertCircleOutline, {
                      key: 1,
                      size: 16
                    }))
              ], 42, _hoisted_5))
            : ($options.showLoadingIcon)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  title: $options.loadingIconTitle,
                  class: "icon-loading-small message-status",
                  "aria-label": $options.loadingIconTitle
                }, null, 8, _hoisted_6))
              : ($props.readInfo.showCommonReadIcon)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    title: $props.readInfo.commonReadIconTitle,
                    class: "message-status",
                    "aria-label": $props.readInfo.commonReadIconTitle
                  }, [
                    _createVNode(_component_IconCheckAll, { size: 16 })
                  ], 8, _hoisted_7))
                : ($props.readInfo.showSentIcon)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      title: $props.readInfo.sentIconTitle,
                      class: "message-status",
                      "aria-label": $props.readInfo.sentIconTitle
                    }, [
                      _createVNode(_component_IconCheck, { size: 16 })
                    ], 8, _hoisted_8))
                  : ($props.readInfo.showSilentIcon)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 4,
                        title: $props.readInfo.silentIconTitle,
                        class: "message-status",
                        "aria-label": $props.readInfo.silentIconTitle
                      }, [
                        _createVNode(_component_IconBellOffOutline, { size: 16 })
                      ], 8, _hoisted_9))
                    : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!$options.isDeletedMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          ($options.isThreadStarterMessage)
            ? (_openBlock(), _createBlock(_component_NcButton, {
                key: 0,
                class: "message-actions__thread",
                size: "small",
                onClick: $options.handleThreadClick
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconArrowLeftTop, {
                    class: "bidirectional-icon",
                    size: 16
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString($options.threadNumReplies), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}